export const ICD10_CHIP_HEIGHT = '24px';
